import React, { useEffect, useContext } from 'react';
import { Outlet } from 'react-router-dom';
import { SidebarContext } from 'context/SidebarContext';
import { useNavigate } from 'react-router';

export default function MainLayout() {
  const navigate = useNavigate();
  const { checkLogin } = useContext(SidebarContext);

  useEffect(() => {
    if (checkLogin()) {
      navigate('/roles', { replace: true });
    }
  }, [navigate]);

  return (
    <div>
      <Outlet />
    </div>
  );
}
